if (typeof window.formatMoney !== 'function') {
  window.formatMoney = function (cents) {
    const value = Number(cents ?? 0) / 100;
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat('uk-UA', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  };
}

function replaceSectionByIdFromHtml(sectionHtml, expectedHandle) {
  if (!sectionHtml) return false;
  const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const incoming = doc.querySelector(`.shopify-section[id^="shopify-section-${expectedHandle}"]`);
  if (!incoming) return false;

  const current = document.getElementById(incoming.id);
  if (!current) return false;

  current.outerHTML = incoming.outerHTML;
  return true;
}

function parseSectionHTML(html, selector) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const node = selector ? doc.querySelector(selector) : doc.body;
  return node ? node.innerHTML : '';
}

function updateHeaderCartCount(count) {
  const n = Number(count) || 0;
  document.querySelectorAll('.cart-count-bubble').forEach((el) => {
    if (el.closest('#CartDrawer')) return;
    if (el.closest('[id^="shopify-section-cart-icon-bubble"]')) return;

    const numEl = el.querySelector('span[aria-hidden="true"]');
    const srEl = el.querySelector('.visually-hidden');

    if (numEl) numEl.textContent = String(n);

    const itemLabel = (window.cartStrings && window.cartStrings.item) || 'item';
    const itemsLabel = (window.cartStrings && window.cartStrings.items) || 'items';
    if (srEl) srEl.textContent = n === 1 ? `1 ${itemLabel}` : `${n} ${itemsLabel}`;
  });
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      e.preventDefault();
      (this.closest('cart-items') || this.closest('cart-drawer-items')).updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.get('cart-remove-button') || customElements.define('cart-remove-button', CartRemoveButton);

if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
      this.removeDisabledState();
    }
    connectedCallback() {
      setTimeout(() => this.removeDisabledState(), 10);
    }
    removeDisabledState() {
      this.querySelectorAll('button').forEach((button) => {
        button.classList.remove('disabled');
        button.removeAttribute('disabled');
      });
    }
    onInputChange() {
      this.validateQtyRules();
      this.removeDisabledState();
    }
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      if (event.target.name === 'plus') this.input.stepUp();
      else this.input.stepDown();

      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

      if (this.input.value === '0') {
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        const removeButton = this.closest('.cart-item')?.querySelector('cart-remove-button');
        if (cartItems && removeButton) {
          removeButton.click();
          return;
        }
      }
      this.validateQtyRules();
      this.removeDisabledState();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.hasAttribute('min')) {
        const min = 0;
        if (value < min) this.input.value = min;
      }
      if (this.input.hasAttribute('max')) {
        const max = parseInt(this.input.getAttribute('max'));
        if (value > max) this.input.value = max;
      }
      this.removeDisabledState();
    }
  }
  customElements.define('quantity-input', QuantityInput);
} else {
  const existingQuantityInput = customElements.get('quantity-input');
  const originalOnButtonClick = existingQuantityInput.prototype.onButtonClick;
  const originalValidateQtyRules = existingQuantityInput.prototype.validateQtyRules;
  const originalConnectedCallback = existingQuantityInput.prototype.connectedCallback;

  existingQuantityInput.prototype.removeDisabledState = function () {
    this.querySelectorAll('button').forEach((button) => {
      button.classList.remove('disabled');
      button.removeAttribute('disabled');
    });
  };
  existingQuantityInput.prototype.connectedCallback = function () {
    if (originalConnectedCallback) originalConnectedCallback.call(this);
    setTimeout(() => this.removeDisabledState(), 10);
  };
  existingQuantityInput.prototype.onButtonClick = function (event) {
    const result = originalOnButtonClick.call(this, event);
    if (this.input.value === '0') {
      return;
    }
    this.removeDisabledState();
    return result;
  };
  existingQuantityInput.prototype.validateQtyRules = function () {
    if (originalValidateQtyRules) originalValidateQtyRules.call(this);
    this.removeDisabledState();
  };
  document.querySelectorAll('quantity-input').forEach((el) => el.removeDisabledState?.());
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    if (document.querySelector('.cart-shipping')) {
      this.minSpend = document.querySelector('.cart-shipping').dataset.minSpend;
      this.minTotal = Math.round(this.minSpend * (Shopify.currency?.rate || 1));
      this.cartShipping();
    }

    const debouncedChange = debounce((e) => this.onChange(e), ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', debouncedChange.bind(this));
    setTimeout(() => this.removeQuantityDisabledStates(), 100);
  }

  removeQuantityDisabledStates() {
    this.querySelectorAll('quantity-input').forEach((q) => q.removeDisabledState?.());
  }

  cartUpdateUnsubscriber = void 0;

  cartShipping() {
    const cartShippingEl = document.querySelector('.cart-shipping');
    if (!cartShippingEl) return;

    this.total = parseInt(cartShippingEl.dataset.total);
    this.minTotal = parseInt(cartShippingEl.dataset.minSpend);

    this.generateProgressCircles();
    this.updateProgressCircles();

    const defaultMsg = document.querySelector('.cart-shipping__message_default');
    const successMsg = document.querySelector('.cart-shipping__message_success');

    if (this.minTotal > this.total) {
      const diff = this.minTotal - this.total;
      const msg = cartShippingEl.dataset.message.replace('||amount||', formatMoney(diff));
      defaultMsg?.classList.add('active');
      if (defaultMsg) defaultMsg.innerHTML = msg;
      successMsg?.classList.remove('active');
    } else {
      defaultMsg?.classList.remove('active');
      successMsg?.classList.add('active');
    }
  }

  generateProgressCircles() {
    const progressBar = document.querySelector('.cart-shipping__progress-bar');
    if (!progressBar || progressBar.hasAttribute('data-initialized')) return;

    progressBar.innerHTML = '';
    progressBar.setAttribute('data-initialized', 'true');

    setTimeout(() => {
      const containerWidth = progressBar.offsetWidth || 280;
      const circleWidth = 6;
      const gap = 7;
      const totalCircleSpace = circleWidth + gap;
      const maxCircles = Math.floor((containerWidth + gap) / totalCircleSpace);
      const circleCount = Math.max(20, maxCircles);
      for (let i = 0; i < circleCount; i++) {
        const circle = document.createElement('div');
        circle.className = 'cart-shipping__circle';
        progressBar.appendChild(circle);
      }
      this.updateProgressCircles();
    }, 50);
  }

  updateProgressCircles() {
    const progressBar = document.querySelector('.cart-shipping__progress-bar');
    if (!progressBar) return;
    const circles = progressBar.querySelectorAll('.cart-shipping__circle');
    if (!circles.length) return;
    const progress = Math.min((this.total || 0) / (this.minTotal || 1), 1);
    const filled = Math.floor(progress * circles.length);
    circles.forEach((c, i) => c.classList.toggle('filled', i < filled));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      if (e.source !== 'cart-items') this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }

  onChange(e) {
    this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    if (typeof fetch === 'undefined') return;
    fetch(routes.cart_url + '?section_id=main-cart-items')
      .then((res) => res.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
        this.innerHTML = parsed.innerHTML;
        setTimeout(() => this.removeQuantityDisabledStates(), 50);
      })
      .catch(console.error);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents-totals',
      },
      {
        id: 'main-cart-shipping',
        section: document.getElementById('main-cart-shipping')?.dataset.id || null,
        selector: '.js-contents-shipping',
      },
    ];
  }

  updateQuantity(line, quantity, inputName) {
    this.enableLoading(line);
    this.querySelectorAll('.quantity__button').forEach((btn) => btn.classList.add('disabled'));

    document.querySelectorAll('.card--product .card__add-to-cart button[name="add"]').forEach((btn) => {
      btn.setAttribute('aria-disabled', false);
      btn.querySelector('span')?.classList.remove('hidden');
      btn.querySelector('.sold-out-message')?.classList.add('hidden');
    });

    const baseSections = this.getSectionsToRender()
      .map((s) => s.section)
      .filter(Boolean);
    const needDrawer = document.getElementById('CartDrawer') ? ['cart-drawer'] : [];
    const sections = Array.from(new Set([...baseSections, ...needDrawer, 'cart-icon-bubble']));

    const body = JSON.stringify({
      line,
      quantity,
      sections,
      sections_url: window.location.pathname,
    });

    if (typeof fetch === 'undefined' || typeof routes === 'undefined') return;

    const drawerEl = document.querySelector('cart-drawer');
    const wasEmpty = !!drawerEl?.classList.contains('is-empty');

    fetch(routes.cart_change_url, { ...fetchConfig(), body })
      .then((res) => res.text())
      .then((text) => {
        const data = JSON.parse(text);
        const qtyInput =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const cartItems = document.querySelectorAll('.cart-item');

        if (data.errors) {
          if (qtyInput) qtyInput.value = qtyInput.getAttribute('value');
          this.updateLiveRegions(line, data.errors);
          const soldOutMsg = this.submitButton?.querySelector('.sold-out-message');
          if (soldOutMsg && this.submitButton) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span')?.classList.add('hidden');
            soldOutMsg.classList.remove('hidden');
            this.error = true;
          }
          return;
        }

        const nowEmpty = data.item_count === 0;

        this.getSectionsToRender().forEach(({ id, section, selector }) => {
          if (!section || !data.sections?.[section]) return;
          const scope = document.getElementById(id);
          if (scope) {
            const container = selector ? scope.querySelector(selector) : scope;
            if (container) container.innerHTML = parseSectionHTML(data.sections[section], selector);
          }
        });

        if (drawerEl && data.sections?.['cart-drawer']) {
          if (typeof drawerEl.renderContents === 'function' && wasEmpty !== nowEmpty) {
            drawerEl.renderContents({ id: null, sections: data.sections });
          } else {
            const fullHtml = data.sections['cart-drawer'];
            const root = document.getElementById('CartDrawer');
            if (root) {
              const patch = (sel) => {
                const html = parseSectionHTML(fullHtml, sel);
                const node = root.querySelector(sel);
                if (node && html) node.innerHTML = html;
              };
              patch('.drawer__header');
              patch('.drawer__items');
              patch('.drawer__footer');
              const upsellHtml = parseSectionHTML(fullHtml, '.js-upsell-slot');
              const upsellEl = root.querySelector('.js-upsell-slot');
              if (upsellEl && upsellHtml !== '') upsellEl.innerHTML = upsellHtml;
            }
          }
          const footer = document.querySelector('#CartDrawer .drawer__footer');
          drawerEl.classList.toggle('is-empty', nowEmpty);
          footer?.classList.toggle('is-empty', nowEmpty);
        }

        if (data.sections?.['cart-icon-bubble']) {
          replaceSectionByIdFromHtml(data.sections['cart-icon-bubble'], 'cart-icon-bubble');
        }
        updateHeaderCartCount(data.item_count);

        const newQty = data.items[line - 1]?.quantity;
        let errorMsg = '';
        if (cartItems.length === data.items.length && newQty !== parseInt(qtyInput?.value || 0)) {
          errorMsg =
            newQty === undefined
              ? window.cartStrings.error
              : window.cartStrings.quantityError.replace('[quantity]', newQty);
        }
        this.updateLiveRegions(line, errorMsg);

        const cartItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (cartItem && cartItem.querySelector?.(`[name="${inputName}"]`)) {
          if (drawerEl) {
            trapFocus?.(drawerEl, cartItem.querySelector(`[name="${inputName}"]`));
          } else {
            cartItem.querySelector(`[name="${inputName}"]`).focus();
          }
        } else if (nowEmpty && drawerEl) {
          const emptyWrap = drawerEl.querySelector('.drawer__inner-empty');
          trapFocus?.(emptyWrap || drawerEl, emptyWrap?.querySelector('a') || drawerEl.querySelector('.drawer__close'));
        } else if (document.querySelector('.cart-item') && drawerEl) {
          trapFocus?.(drawerEl, document.querySelector('.cart-item__name'));
        }
        this.error = false;
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((el) => el.classList.add('hidden'));
        this.querySelectorAll('.quantity__button').forEach((btn) => btn.classList.remove('disabled'));
        const errEl = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errEl) errEl.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.querySelectorAll('.quantity__button').forEach((btn) => btn.classList.remove('disabled'));
        setTimeout(async () => {
          try {
            const cart = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then((r) =>
              r.json()
            );
            publish?.(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              items: cart?.items?.map(({ variant_id, quantity }) => ({ variant_id, quantity })),
            });
            document.querySelector('cart-drawer-items')?.updateShippingUI?.(cart?.total_price);
          } catch (e) {
            /* noop */
          }
          this.removeQuantityDisabledStates();
        }, 100);
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const errorEl =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (errorEl) {
      errorEl.style.display = 'flex';
      errorEl.querySelector('.cart-item__error-text').innerHTML = message || '';
    }
    this.lineItemStatusElement?.setAttribute('aria-hidden', true);
    const liveRegion =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    liveRegion?.setAttribute('aria-hidden', false);
    setTimeout(() => liveRegion?.setAttribute('aria-hidden', true), 1000);
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    if (!mainCartItems) return;
    mainCartItems.classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((el) => el.classList.remove('hidden'));
    document.activeElement?.blur?.();
    this.lineItemStatusElement?.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    if (!mainCartItems) return;
    mainCartItems.classList.remove('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((el) => el.classList.add('hidden'));
  }
}
customElements.get('cart-items') || customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'change',
          debounce((e) => {
            const body = JSON.stringify({ note: e.target.value });
            if (typeof fetch !== 'undefined' && typeof routes !== 'undefined') {
              fetch(routes.cart_update_url, { ...fetchConfig(), body });
            }
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    if (this.header) this.header.preventHide = false;

    this.addEventListener('keyup', (e) => {
      if (e.code === 'Escape') this.close();
    });
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.addEventListener('mousedown', (e) => {
      const inner = this.querySelector('.drawer__inner');
      if (!inner) return;
      if (!inner.contains(e.target)) {
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const bubble = document.querySelector('#cart-icon-bubble');
    if (!bubble) return;
    bubble.setAttribute('role', 'button');
    bubble.setAttribute('aria-haspopup', 'dialog');
    bubble.addEventListener('click', (e) => {
      e.preventDefault();
      this.open(bubble);
    });
    bubble.addEventListener('keydown', (e) => {
      if ((e.code || '').toUpperCase() === 'SPACE') {
        e.preventDefault();
        this.open(bubble);
      }
    });
  }

  open(triggerElement) {
    if (this.header) this.header.preventHide = true;
    if (triggerElement) this.setActiveElement(triggerElement);
    const summary = this.querySelector('[id^="Details-"] summary');
    if (summary && !summary.hasAttribute('role')) this.setSummaryAccessibility(summary);
    setTimeout(() => this.classList.add('animate', 'active'));
    this.addEventListener(
      'transitionend',
      () => {
        const drawerContent = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus?.(drawerContent, focusElement);
      },
      { once: true }
    );
    document.body.classList.add('overflow-hidden-drawer');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus?.(this.activeElement);
    document.body.classList.remove('overflow-hidden-drawer');
    if (this.header) this.header.preventHide = false;
  }

  setSummaryAccessibility(summary) {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');
    const nextSibling = summary.nextElementSibling;
    if (nextSibling?.id) summary.setAttribute('aria-controls', nextSibling.id);
    summary.addEventListener('click', () => {
      const isOpen = summary.closest('details').hasAttribute('open');
      summary.setAttribute('aria-expanded', String(!isOpen));
    });
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(data) {
    this.productId = data.id;

    this.getSectionsToRender().forEach((section) => {
      const container = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (container) container.innerHTML = parseSectionHTML(data.sections[section.id], section.selector);
    });

    if (data.sections?.['cart-icon-bubble']) {
      replaceSectionByIdFromHtml(data.sections['cart-icon-bubble'], 'cart-icon-bubble');
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this, false));
      this.setHeaderCartIconAccessibility();
      this.open();
    });
  }

  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }

  setActiveElement(el) {
    this.activeElement = el;
  }
}
customElements.get('cart-drawer') || customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const id = 'CartDrawer';
    return [
      { id, section: 'cart-drawer', selector: '.drawer__header' },
      { id, section: 'cart-drawer', selector: '.drawer__items' },
      { id, section: 'cart-drawer', selector: '.drawer__footer' },
      { id, section: 'cart-drawer', selector: '.js-upsell-slot' },
    ];
  }

  updateShippingUI(totalCents) {
    const ship = document.querySelector('.cart-shipping');
    if (!ship || typeof totalCents !== 'number') return;
    ship.dataset.total = String(totalCents);
    this.total = totalCents;
    this.minTotal = parseInt(ship.dataset.minSpend);
    this.updateProgressCircles();

    const defaultMsg = document.querySelector('.cart-shipping__message_default');
    const successMsg = document.querySelector('.cart-shipping__message_success');
    if (this.minTotal > this.total) {
      const diff = this.minTotal - this.total;
      const msg = ship.dataset.message.replace('||amount||', formatMoney(diff));
      if (defaultMsg) {
        defaultMsg.innerHTML = msg;
        defaultMsg.classList.add('active');
      }
      successMsg?.classList.remove('active');
    } else {
      defaultMsg?.classList.remove('active');
      successMsg?.classList.add('active');
    }
  }

  enableLoading() {
    const footer = document.querySelector('#CartDrawer .drawer__footer');
    if (footer) {
      footer.querySelector('.totals__subtotal-value > span')?.classList.add('disabled');
      footer.querySelector('.loading-overlay')?.classList.remove('hidden');
      document.activeElement?.blur?.();
    }
  }
  disableLoading() {
    const footer = document.querySelector('#CartDrawer .drawer__footer');
    if (footer) {
      footer.querySelector('.totals__subtotal-value > span')?.classList.remove('disabled');
      footer.querySelector('.loading-overlay')?.classList.add('hidden');
    }
  }
}
customElements.get('cart-drawer-items') || customElements.define('cart-drawer-items', CartDrawerItems);

class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.querySelectorAll('.variant-selector').forEach((sel) =>
      sel.addEventListener('change', this.onVariantChange.bind(this))
    );
    this.querySelectorAll('.complementary-product__form').forEach((form) =>
      form.addEventListener('submit', this.onFormSubmit.bind(this))
    );
  }

  connectedCallback() {
    this.initVariantUIs();
    requestAnimationFrame(() => this.initSwiper());
  }

  formatMoney(cents) {
    return window.formatMoney(cents);
  }

  buildSectionsUrl() {
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    return `/?sections=${encodeURIComponent(sections.join(','))}&sections_url=${encodeURIComponent(
      window.location.pathname
    )}`;
  }

  updateDrawerSections(sectionsData) {
    const drawer = document.querySelector('cart-drawer');
    const root = document.getElementById('CartDrawer');
    const fullHtml = sectionsData['cart-drawer'] || '';
    if (!root || !fullHtml) return;

    const parse = (sel) => {
      const doc = new DOMParser().parseFromString(fullHtml, 'text/html');
      const node = sel ? doc.querySelector(sel) : doc.body;
      return node ? node.innerHTML : '';
    };

    const willBeEmpty = !!new DOMParser().parseFromString(fullHtml, 'text/html').querySelector('.drawer__empty');
    const wasEmpty = !!document.querySelector('.drawer__empty');
    const layoutChanged = wasEmpty !== willBeEmpty;

    if (layoutChanged) {
      const oldShipping = root.querySelector('.cart-shipping');
      const newInner = parse('#CartDrawer');
      if (newInner) {
        root.innerHTML = newInner;
        const newShipping = root.querySelector('.cart-shipping');
        if (oldShipping && newShipping) newShipping.replaceWith(oldShipping);
      }
    } else {
      const patch = (sel) => {
        const html = parse(sel);
        const node = root.querySelector(sel);
        if (node && html !== '') node.innerHTML = html;
      };
      patch('.drawer__header');
      patch('.drawer__items');
      patch('.drawer__footer');
      const upsellHtml = parse('.js-upsell-slot');
      const upsellSlot = root.querySelector('.js-upsell-slot');
      if (upsellSlot && upsellHtml !== '') upsellSlot.innerHTML = upsellHtml;
    }

    if (sectionsData['cart-icon-bubble']) {
      replaceSectionByIdFromHtml(sectionsData['cart-icon-bubble'], 'cart-icon-bubble');
    }

    if (drawer && !drawer.classList.contains('active')) drawer.open?.();

    setTimeout(async () => {
      try {
        const cart = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then((r) =>
          r.json()
        );
        document.querySelector('cart-drawer-items')?.updateShippingUI?.(cart?.total_price);
        updateHeaderCartCount(cart?.item_count);
      } catch (e) {
        /* noop */
      }
      document.querySelectorAll('quantity-input').forEach((q) => q.removeDisabledState?.());
    }, 50);
  }

  onVariantChange(e) {
    const selector = e.target;
    const productId = selector.dataset.productId;
    const variantId = selector.value;
    const optionEl = selector.selectedOptions?.[0];
    const priceCents = Number(optionEl?.dataset?.price ?? 0);
    const compareCts = Number(optionEl?.dataset?.comparePrice ?? optionEl?.dataset?.compare_price ?? 0);
    const imageCts = optionEl?.dataset?.variantImage;

    const wrapper = this.querySelector(`.complementary-product[data-product-id="${productId}"]`);
    if (!wrapper) return;

    const priceEl = wrapper.querySelector('.button-price');
    const imageEl = wrapper.querySelector('.complementary-product__image img');
    const hiddenInput = wrapper.querySelector('.variant-id');

    if (hiddenInput) hiddenInput.value = variantId;
    if (priceEl) {
      const current = this.formatMoney(priceCents);
      const compare = compareCts > priceCents ? ` <s>${this.formatMoney(compareCts)}</s>` : '';
      priceEl.innerHTML = `${current}${compare}`;
    }

    if (imageEl && imageCts) {
      imageEl.src = imageCts;
      imageEl.srcset = imageCts + ' 80w';
    }

    const displayBtn = selector.parentElement?.querySelector('.cp-variant-display');
    if (displayBtn)
      displayBtn.querySelector('.cp-variant-display__text').textContent = optionEl?.textContent?.trim() || '';
  }

  async onFormSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const btn = form.querySelector('button[type="submit"]');
    const labelEl = btn?.querySelector('.button-text') || btn;

    const setState = (busy) => {
      if (btn) {
        btn.disabled = busy;
        btn.classList.toggle('is-loading', busy);
        btn.setAttribute('aria-busy', String(busy));
        if (busy) {
          if (!btn.dataset.originalLabel) btn.dataset.originalLabel = (labelEl.textContent || '').trim();
          labelEl.textContent = 'Adding…';
        } else {
          labelEl.textContent = btn.dataset.originalLabel || 'Add';
        }
      }
      this.classList.toggle('disabled', busy);
    };

    try {
      setState(true);

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      });
      if (!addRes.ok) {
        console.error('Add to cart error:', await addRes.text());
        return;
      }

      const sectionsRes = await fetch(this.buildSectionsUrl(), {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sectionsData = await sectionsRes.json();
      this.updateDrawerSections(sectionsData);

      publish?.(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
    } catch (err) {
      console.error(err);
    } finally {
      setState(false);
    }
  }

  initVariantUIs() {
    this.querySelectorAll('.variant-selector').forEach((selectEl) => {
      selectEl.classList.add('cp-variant-hidden');
      if (selectEl.parentElement.querySelector('.cp-variant')) return;

      const container = document.createElement('div');
      container.className = 'cp-variant';

      const displayBtn = document.createElement('button');
      displayBtn.type = 'button';
      displayBtn.className = 'cp-variant-display';
      displayBtn.setAttribute('aria-haspopup', 'listbox');
      displayBtn.setAttribute('aria-expanded', 'false');

      const displayText = document.createElement('span');
      displayText.className = 'cp-variant-display__text';
      displayText.textContent = selectEl.selectedOptions[0]?.textContent?.trim() || '';

      const displayArrow = document.createElement('span');
      displayArrow.className = 'cp-variant-display__arrow';
      displayArrow.innerHTML = '↓';

      displayBtn.appendChild(displayText);
      displayBtn.appendChild(displayArrow);

      displayBtn.addEventListener('click', () => {
        if (displayBtn.getAttribute('aria-expanded') === 'true') {
          this.closePortal(displayBtn);
        } else {
          this.openPortalForSelect(selectEl, displayBtn);
        }
      });

      selectEl.parentElement.appendChild(container);
      container.appendChild(displayBtn);
    });
  }

  getPortal() {
    const existing = document.querySelector('cart-drawer #cp-variant-root');
    if (existing) {
      const pop = existing.querySelector('.cp-variant-popover');
      const list = existing.querySelector('.cp-variant-list');
      const closeBtn = existing.querySelector('.cp-variant-close');
      return { root: existing, pop, list, closeBtn };
    }

    const root = document.createElement('div');
    root.id = 'cp-variant-root';
    root.setAttribute('aria-hidden', 'true');

    const backdrop = document.createElement('div');
    backdrop.className = 'cp-variant-backdrop';

    const pop = document.createElement('div');
    pop.className = 'cp-variant-popover';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'true');
    pop.setAttribute('tabindex', '-1');

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'cp-variant-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML =
      '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.813477 0.509766C0.86997 0.510218 0.925732 0.522424 0.977539 0.544922C1.02862 0.567129 1.07473 0.599461 1.11328 0.639648L7.47656 7.00195L13.8398 0.639648C13.9152 0.561018 14.0181 0.51406 14.127 0.509766H14.1279C14.2125 0.507754 14.2962 0.53207 14.3672 0.578125C14.4381 0.624174 14.4938 0.690595 14.5264 0.768555C14.5589 0.84652 14.5668 0.932884 14.5498 1.01562C14.5328 1.09778 14.4907 1.17193 14.4307 1.23047L14.4316 1.23145L8.06836 7.59473L14.4863 14.0127C14.5047 14.0353 14.5208 14.0598 14.5342 14.0859C14.561 14.1384 14.5759 14.1961 14.5791 14.2549C14.5822 14.3137 14.5728 14.3727 14.5518 14.4277C14.5306 14.4828 14.4987 14.5335 14.457 14.5752C14.4153 14.6169 14.3646 14.6488 14.3096 14.6699C14.2546 14.6909 14.1955 14.7004 14.1367 14.6973C14.078 14.6941 14.0202 14.6791 13.9678 14.6523C13.9186 14.6272 13.8756 14.5918 13.8398 14.5498L7.47656 8.18652L1.11328 14.5498C1.07752 14.5918 1.03451 14.6272 0.985352 14.6523C0.932963 14.6791 0.875152 14.6941 0.816406 14.6973C0.757633 14.7004 0.698525 14.6909 0.643555 14.6699C0.588543 14.6488 0.537792 14.6169 0.496094 14.5752C0.454386 14.5335 0.422478 14.4828 0.401367 14.4277C0.380286 14.3727 0.370896 14.3137 0.374023 14.2549C0.377186 14.1961 0.392153 14.1384 0.418945 14.0859C0.43228 14.0598 0.448453 14.0353 0.466797 14.0127L6.88477 7.59473L0.521484 1.23145V1.23047C0.462401 1.17268 0.420624 1.09941 0.40332 1.01855C0.385856 0.936926 0.393803 0.851921 0.424805 0.774414C0.455808 0.696906 0.509182 0.630075 0.578125 0.583008C0.646971 0.536086 0.728213 0.51044 0.811523 0.509766H0.813477Z" fill="#101010" fill-opacity="0.8" stroke="#101010" stroke-width="0.206713"/></svg>';

    const list = document.createElement('ul');
    list.className = 'cp-variant-list';

    pop.appendChild(closeBtn);
    pop.appendChild(list);
    root.appendChild(backdrop);
    root.appendChild(pop);

    const drawer = document.querySelector('cart-drawer');
    const anchor = drawer?.querySelector('.drawer__footer');
    if (anchor?.parentNode) anchor.insertAdjacentElement('afterend', root);
    else if (drawer) drawer.appendChild(root);
    else document.body.appendChild(root);

    backdrop.addEventListener('click', () => this.closePortal());
    closeBtn.addEventListener('click', () => this.closePortal());
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closePortal();
    });

    return { root, pop, list, closeBtn };
  }

  openPortalForSelect(selectEl, btn) {
    const portal = this.getPortal();
    portal.list.innerHTML = '';

    Array.from(selectEl.options).forEach((opt) => {
      if (opt.disabled) return;

      const li = document.createElement('li');
      li.className = 'cp-variant-item';
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', opt.value);
      if (opt.selected) li.setAttribute('aria-selected', 'true');

      const swatch = document.createElement('span');
      swatch.className = 'cp-variant-swatch';
      const swatchImg = opt.dataset.swatchImage;
      const isDark = opt.dataset.swatchDark === 'true';
      if (swatchImg) {
        swatch.style.backgroundImage = `url(${swatchImg})`;
        swatch.style.backgroundSize = 'cover';
        swatch.style.backgroundPosition = 'center';
      }
      if (isDark) swatch.classList.add('cp-variant-swatch--dark');

      const name = document.createElement('span');
      name.className = 'cp-variant-name';
      name.textContent = (opt.textContent || '').trim() + ' - ';

      const priceWrap = document.createElement('span');
      priceWrap.className = 'cp-variant-price';
      const price = Number(opt.dataset.price || 0);
      const compare = Number(opt.dataset.comparePrice || opt.dataset.compare_price || 0);
      const freePrice = JSON.parse(opt.dataset.freePrice || 'false');
      if (freePrice) {
        priceWrap.innerHTML = '<span class="cp-variant-price-free"> Free </span>';
      } else {
        priceWrap.innerHTML = this.formatMoney(price) + (compare > price ? ` <s>${this.formatMoney(compare)}</s>` : '');
      }

      li.appendChild(swatch);
      li.appendChild(name);
      li.appendChild(priceWrap);

      li.addEventListener('click', () => {
        selectEl.value = opt.value;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        portal.list
          .querySelectorAll('.cp-variant-item[aria-selected="true"]')
          .forEach((el) => el.removeAttribute('aria-selected'));
        li.setAttribute('aria-selected', 'true');
        this.closePortal(btn);
      });

      portal.list.appendChild(li);
    });

    portal.root.classList.add('open');
    portal.root.removeAttribute('aria-hidden');
    btn.setAttribute('aria-expanded', 'true');
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.add('select-opened');
    (portal.list.querySelector('.cp-variant-item') || portal.closeBtn)?.focus?.();

    this._currentTriggerBtn = btn;
  }

  closePortal(btn = this._currentTriggerBtn) {
    const portal = this.getPortal();
    portal.root.classList.remove('open');
    portal.root.setAttribute('aria-hidden', 'true');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.remove('select-opened');
    this._currentTriggerBtn = null;
  }

  initSwiper() {
    if (!window.Swiper || this.swiper) return;
    const list = this.querySelector('.complementary-products__list');
    if (!list) return;

    list.classList.add('swiper');
    list.style.overflow = 'visible';

    if (!list.querySelector('.swiper-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      Array.from(list.children).forEach((child) => {
        if (!(child instanceof HTMLElement)) return;
        if (child.classList.contains('swiper-wrapper') || child.classList.contains('swiper-pagination')) return;
        child.classList.add('swiper-slide');
        if (child.classList.contains('complementary-product')) {
          child.style.width = '90%';
          wrapper.appendChild(child);
        }
      });
      list.appendChild(wrapper);
    }

    let pag = list.querySelector('.swiper-pagination');
    if (!pag) {
      pag = document.createElement('div');
      pag.className = 'swiper-pagination';
      list.appendChild(pag);
    }

    this.swiper = new window.Swiper(list, {
      slidesPerView: 'auto',
      spaceBetween: 4,
      pagination: { el: pag, clickable: true },
      watchOverflow: true,
      observer: true,
      observeParents: true,
    });
  }
}
customElements.get('complementary-products') || customElements.define('complementary-products', ComplementaryProducts);
